import { motion } from "framer-motion";
import { Flag, Sparkles } from "lucide-react";

const R = 54;
const C = 2 * Math.PI * R;

const message = (done, total, next) => {
  if (!total) return "Our classes are being prepared. Check back soon!";
  if (done === total) return "You've completed every step of the journey. Praise God! Now help someone else take theirs.";
  if (!done) return `Every journey starts with one step. ${next?.title} is a great place to begin.`;
  if (done / total >= 0.5) return `You're more than halfway there — ${next?.title} is next!`;
  return `Great start! Keep going — ${next?.title} is your next step.`;
};

export const JourneySnapshot = ({ done, total, next }) => {
  const pct = total ? Math.round((done / total) * 100) : 0;
  return (
    <div className="grid items-center gap-8 rounded-[2rem] bg-[#0A3A6B] p-7 text-white shadow-xl sm:grid-cols-[auto_1fr] sm:p-10" data-testid="journey-snapshot">
      <div className="relative mx-auto h-40 w-40">
        <svg viewBox="0 0 120 120" className="h-full w-full -rotate-90">
          <circle cx="60" cy="60" r={R} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="10" />
          <motion.circle cx="60" cy="60" r={R} fill="none" stroke="#7DD3FC" strokeWidth="10" strokeLinecap="round"
            strokeDasharray={C} initial={{ strokeDashoffset: C }} animate={{ strokeDashoffset: C - (C * pct) / 100 }} transition={{ duration: 1.2, ease: "easeOut" }} />
        </svg>
        <div className="absolute inset-0 grid place-items-center text-center">
          <div><p className="text-4xl font-bold" data-testid="journey-percent">{pct}%</p><p className="text-xs text-sky-200">of your journey</p></div>
        </div>
      </div>
      <div>
        <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-sky-300"><Sparkles className="h-4 w-4" /> Your journey snapshot</p>
        <h2 className="mt-2 text-2xl font-bold tracking-tight sm:text-3xl" data-testid="journey-step-count">
          {total ? (done === total ? "Journey complete!" : `Step ${done + 1} of ${total}`) : "Coming soon"}
        </h2>
        <p className="mt-2 max-w-lg text-sky-100/85" data-testid="journey-message">{message(done, total, next)}</p>
        {next && done < total && (
          <a href={`#class-${next.id}`} className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2 text-sm font-semibold text-[#0A3A6B] transition-transform hover:-translate-y-0.5" data-testid="journey-next-step-link">
            <Flag className="h-4 w-4" /> Your next step: {next.title}
          </a>
        )}
      </div>
    </div>
  );
};
